import { Button, Modal, IconTile } from '@teo/components';
import { useTranslation } from 'react-i18next';
import {
  Training,
  Evaluation,
  Flag,
  DuoToneCourseFilled,
  DuoToneAssessmentFilled,
  DuoToneVacancyFilled,
  Theme,
} from '@teo/components/icons';
import { categoriesIcon } from '@/components/LearningPath/util';

export const MisingConnect = ({
  closeModal,
  misingConnect,
  allCategories,
}: any) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={true}>
      <Modal.Header onClose={closeModal}>
        {t('pages.learning_path.missing_connection')}
      </Modal.Header>
      <Modal.Body>
        <div className="-mx-6 max-h-[70vh] overflow-y-scroll px-6">
          <p className="text-sm text-grey-06">
            {t('pages.learning_path.missing_connection_sub')}
          </p>
          <div className="relative mt-6 mb-4 flex flex-col gap-5">
            {misingConnect?.map((nds: any) => {
              let Icon;
              if (nds?.tags && nds?.type === 'learningpath') {
                const learningpathTags = allCategories?.find(
                  (el: any) => el?.label === nds?.tags.split(':')[1]
                );
                Icon = categoriesIcon(learningpathTags?.icon);
              } else {
                Icon = Theme;
              }
              return (
                <div
                  key={nds?.id}
                  className="flex flex-col rounded-lg border p-2"
                >
                  <div className="flex items-center">
                    <IconTile
                      Icon={
                        nds?.subType === 'training'
                          ? Training
                          : nds?.subType === 'learningpath'
                          ? Icon
                          : nds?.subType === 'milestone'
                          ? Flag
                          : nds?.subType === 'evaluation'
                          ? Evaluation
                          : nds?.subType === 'course'
                          ? DuoToneCourseFilled
                          : nds?.subType === 'assessment'
                          ? DuoToneAssessmentFilled
                          : nds?.subType === 'leervacature'
                          ? DuoToneVacancyFilled
                          : DuoToneCourseFilled
                      }
                      imageUrl={nds?.picture}
                      color={
                        nds?.subType === 'training'
                          ? 'green'
                          : nds?.subType === 'learningpath'
                          ? 'dark_blue'
                          : nds?.subType === 'milestone'
                          ? 'blue'
                          : nds?.subType === 'evaluation'
                          ? 'purple'
                          : nds?.subType === 'course'
                          ? 'yellow'
                          : nds?.subType === 'assessment'
                          ? 'red'
                          : nds?.subType === 'leervacature'
                          ? 'yellow'
                          : 'yellow'
                      }
                      size="small_md"
                      className={
                        nds?.subType === 'course'
                          ? 'fill-primary-06 text-primary-01'
                          : nds?.subType === 'assessment'
                          ? 'fill-tint-red-dark text-tint-red-light'
                          : nds?.subType === 'leervacature'
                          ? 'fill-error-04 text-error-04'
                          : ''
                      }
                    />
                    <div className="flex flex-1 flex-col gap-1 px-3">
                      <p className="text-xs text-grey-06">
                        {nds?.subType === 'training'
                          ? t('pages.learning_path.training')
                          : nds?.subType === 'learningpath'
                          ? t('pages.learning_path.theme')
                          : nds?.subType === 'milestone'
                          ? t('pages.learning_path.milestone')
                          : nds?.subType === 'evaluation'
                          ? t('pages.learning_path.evaluation')
                          : nds?.subType === 'course'
                          ? t('links.course')
                          : nds?.subType === 'assessment'
                          ? t('links.assessment')
                          : nds?.subType === 'leervacature'
                          ? t('links.vacancy')
                          : t('links.course')}
                      </p>
                      <p
                        className={`max-w-[225px] break-words text-left text-sm font-medium text-black line-clamp-2 `}
                      >
                        {nds?.name}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        cancelButtonLabel={t('button.cancel')}
        onCancel={closeModal}
      ></Modal.Footer>
    </Modal>
  );
};
